/**
 * Illustrative sample report preview — labeled as such. Shows the structure of
 * the review the team prepares from a submitted bill. No invented customer data.
 */
export default function ReportPreview() {
  const sections = [
    ["Usage & billing summary", "12-month billing view built from the bills you submit."],
    ["Energy vs demand charges", "Where your bill comes from, and which part batteries can target."],
    ["Preliminary system-sizing assumptions", "Roof area, yield and offset assumptions — clearly labeled as assumptions."],
    ["Potential solar & storage benefits", "Scenario ranges, not guarantees."],
    ["Ownership, financing & PPA comparison", "Three capital paths compared on the same inputs where applicable."],
    ["Potential tax benefits", "Modeled only; eligibility must be confirmed by your tax adviser."],
    ["Cash-flow & payback summary", "After-tax payback and sensitivity, with assumptions listed."],
    ["Missing information & next steps", "Exactly what we still need from you, and who does what next."],
  ];
  return (
    <div className="report-preview" data-testid="report-preview">
      <span className="eyebrow">WHAT YOU RECEIVE</span>
      <h3>Your bill-based review, section by section.</h3>
      <div className="report-paper" aria-label="Illustrative sample report structure">
        <div className="report-paper-head">
          <b>SOLAR BLACK BELT · BILL REVIEW</b>
          <span className="report-tag">Illustrative sample—not an actual customer assessment</span>
        </div>
        <ol>
          {sections.map(([title, note], i) => (
            <li key={title}>
              <b>
                {i + 1}. {title}
              </b>
              <span>{note}</span>
            </li>
          ))}
        </ol>
        <p className="micro">
          Every section is preliminary until engineering, utility, financing and tax reviews are complete. Unreadable or missing
          bill fields are flagged for you — never guessed.
        </p>
      </div>
    </div>
  );
}
